import { AgentTypeEnum } from '@zaoblako/shared/modules/ai/enums/agent-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link AgentTypeEnum} enumeration values */
export const AgentTypeEnumI18n: EnumI18nInterface<AgentTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AgentTypeEnum.YANDEX]: 'Яндекс GPT',
    [AgentTypeEnum.DEEPSEEK]: 'DeepSeek GPT',
    [AgentTypeEnum.MISTRAL]: 'Mistral GPT',
    [AgentTypeEnum.OPENAI]: 'OpenAI GPT',
  },
  [I18nLocalesEnum.EN_US]: {
    [AgentTypeEnum.YANDEX]: 'Yandex GPT',
    [AgentTypeEnum.DEEPSEEK]: 'DeepSeek GPT',
    [AgentTypeEnum.MISTRAL]: 'Mistral GPT',
    [AgentTypeEnum.OPENAI]: 'OpenAI GPT',
  },
};
